export default __webpack_public_path__ + "static/media/pizza-wine.54e9d1ac.webp";